export default "__VITE_ASSET__pmuPYANS__"